import { useCallback } from "react";
import { useSetAtom } from "jotai";
import { useApi } from "./useApi";
import { isFetchingPaymentSettingsAtom } from "@/store/paymentAtoms";
import type { PaymentSettingsResponse } from "@models/payment";

const PAYMENTS_ENDPOINT = "/payments";

export const usePaymentApi = () => {
    const { callApi } = useApi();
    const setIsFetchingSettings = useSetAtom(isFetchingPaymentSettingsAtom);

    // Admin payment settings (#298). Fetched on demand when the
    // returned-payment-fee dialog opens; the caller holds the value locally.
    const getPaymentSettings =
        useCallback(async (): Promise<PaymentSettingsResponse> => {
            setIsFetchingSettings(true);

            try {
                return await callApi<PaymentSettingsResponse>(
                    `${PAYMENTS_ENDPOINT}/settings`,
                );
            } finally {
                setIsFetchingSettings(false);
            }
        }, [callApi, setIsFetchingSettings]);

    return {
        getPaymentSettings,
    };
};
